import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  CircularProgress,
  Tooltip,
  styled,
} from '@mui/material';
import { ReactNode } from 'react';

const Spinner = styled(CircularProgress, {
  shouldForwardProp: (prop) => prop !== 'iconOnly',
})<{ iconOnly?: boolean }>(({ iconOnly }) => ({
  color: 'rgba(0, 0, 0, 0.26)',
  minWidth: 18,
  minHeight: 18,
  marginRight: iconOnly ? 0 : '10px',
}));

export interface ButtonProps extends MuiButtonProps {
  loading?: boolean;
  iconOnly?: boolean;
  whiteSpace?: 'nowrap' | 'normal';
  tooltip?: string | ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  loading,
  children,
  disabled,
  iconOnly,
  whiteSpace = 'normal',
  tooltip,
  ...props
}) => {
  const button = (
    <MuiButton
      {...props}
      disabled={!!disabled || !!loading}
      sx={{ whiteSpace }}
    >
      {loading ? <Spinner iconOnly={iconOnly} size={18} /> : null}
      {!loading || !iconOnly ? children : null}
    </MuiButton>
  );

  return tooltip ? (
    <Tooltip arrow title={tooltip}>
      <span>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

export default Button;
